export default "__VITE_ASSET__3a4eb173__"